import moment from "moment"
import { useSnackbar } from "notistack"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import AlertGarita from "src/components/layout/AlertGarita"
import Account from "src/components/Topbar/Account"
import {
  selectCamaraGarita,
  selectConjunto,
} from "src/redux/slices/complexSlice"
import {
  deleteVisitaAnticipadaQrByConjunto,
  getVisitaAnticipadaQrByConjunto,
} from "src/views/viewGuardia/alertas/services/firestore"
import Swal from "sweetalert2"
import { Brand, ComplexSwitcher, GaritaLabel } from "./shared"

export const End = () => (
  <>
    <ComplexSwitcher />
    <GaritaLabel />
    <Account />
  </>
)

export const Effects = () => {
  const { enqueueSnackbar } = useSnackbar()
  const conjunto = useSelector(selectConjunto)
  const camaraGarita = useSelector(selectCamaraGarita)

  useEffect(() => {
    const unsub = getVisitaAnticipadaQrByConjunto(
      {
        next: query => {
          query.docChanges().forEach(change => {
            if (change?.type === "added") {
              const alertQr = change.doc?.data?.()
              const { Tipo, Titulo, Mensaje } = alertQr
              if (
                alertQr &&
                moment(alertQr.TiempoEntrada.toDate()).isBetween(
                  moment().startOf("day"),
                  moment().endOf("day")
                )
              ) {
                Swal.fire({
                  icon: Tipo,
                  title: Titulo,
                  text: Mensaje,
                }).then(result => {
                  if (result.isConfirmed) {
                    deleteVisitaAnticipadaQrByConjunto(conjunto.id, alertQr.id)
                      .then(() => {
                        if (Tipo === "success") {
                          enqueueSnackbar("Entrada Registrada", {
                            variant: "success",
                          })
                        }
                      })
                      .catch(() => {})
                  }
                })
              }
            }
          })
        },
      },
      conjunto.id,
      camaraGarita
    )

    return unsub
  }, [camaraGarita, conjunto.id])

  return <AlertGarita />
}

export { Brand }
